import {clickEvent} from "../../../webpack/modules/events";
import {hideLoader, showLoader} from "../../../webpack/modules-optimized/offcanvas";
import {hideElement, showElement} from "../../../webpack/modules/element-visibility";
import {get} from "../../../webpack/modules/ajax";
import {initImageSliders} from "../../../webpack/modules-optimized/reviews";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

clickEvent('#product-page .open-product-reviews', false, async function(element) {
    let container = document.getElementById('reviews-offcanvas');
    let button = container.querySelector('#load-more-product-reviews');
    let productId = element.dataset.productId;
    let reference = element.dataset.productReference;
    let ga4Event = element.dataset.event;
    let page = 1;

    button.dataset.id = productId;
    button.dataset.page = page;
    initImageSliders(container);

    hideLoader(container);
    ga4TrackSimpleEvent({
        'event': ga4Event,
        'method': 'show_product_reviews',
        'content_type': reference
    });
});

clickEvent('#product-page #reviews-offcanvas #load-more-product-reviews', false, async function(element) {
    let container = document.getElementById('reviews-offcanvas');
    let productId = element.dataset.id;
    let page = parseInt(element.dataset.page) + 1;
    let reviewsList = container.querySelector('.reviews-list');
    let button = container.querySelector('#load-more-product-reviews');

    showLoader(container);

    let reviews = await getReviews(productId, page);

    reviewsList.innerHTML += reviews.list;
    button.dataset.page = page;
    initImageSliders(container);
    if (reviews.lastPage === page) hideElement(button);
    hideLoader(container);
});

function getReviews(productId, page)
{
    return new Promise(resolve => {
        let url = '/ajax/website/get-product-reviews-canvas/'+productId;
        if (page > 1) url += '/'+page;
        get(url, {}, (response) => resolve(response));
    });
}